import React, { Component, useEffect, useState } from 'react'
import { Stack, Box, Button, Paper } from '@mui/material'
import * as Loaders from '../../components/UIComponents/Loader'
import * as Icons from '../../components/UIComponents/Icons'
import * as Texts from '../../components/UIComponents/Text'
import * as Buttons from '../../components/UIComponents/Button'
import * as Images from '../../components/UIComponents/Images'
import Loader from '../../components/UIComponents/Loader'
import Carousel from 'react-material-ui-carousel'
import { getLinkPreview, getPreviewFromContent } from "link-preview-js"
import { Link } from 'react-router-dom'
function urlify(text) {
    var urlRegex = /(https?:\/\/[^\s]+)/g;
    return text.replace(urlRegex, function(url) {
      return '<a href="' + url + '">' + url + '</a>';
    })
    // or alternatively
    // return text.replace(urlRegex, '<a href="$1">$1</a>')
}
const UrlContentPreview = ({
    pathObj
}) => {
    console.log("loaded path object", pathObj)
    let toRenderContents = []
    Object.keys(pathObj).map((key, idx) => {
        let targetObj = pathObj[key]
        if (!targetObj?.path || !targetObj?.url) return
        if(!urlify(targetObj?.url)) return
        toRenderContents.push(<ContentPaper
            key={`nurse-carousel-${idx}-${targetObj?.path}`}
            url={targetObj?.url}
            title={targetObj?.path}
        />)
    })

    return (<Carousel>
        {toRenderContents}
    </Carousel>)
}

const ContentPaper = ({
    url,
    title
}) => {
    console.log("got url", url)
    useEffect(() => {
        // getLinkPreview(url).then((data) => console.debug(data));
          
    }, [])

    return (<Paper elevation={4}
        sx={{
            maxWidth: 184,
            maxHeight: 240,
            width: 184,
            height: 240,
            px: 2,
            pt: 3,
            pb: 3
        }}
    >
        <Stack spacing={2} direction={"column"} justifyContent={'flex-start'}
            sx={{
                height: 1
            }}
        >
            <Texts.Title>{title.length >=12 ? `${title.slice(0, 12)}...`:title}</Texts.Title>
            <Box
                sx={{
                    display: 'flex',
                    flexGrow: 1,
                    justifyContent: 'flex-start',
                    maxHeight: 90,
                    overflow: 'hidden'
                }}
            >
                <Texts.Tip>{url}</Texts.Tip>
            </Box>
            <Box
                sx={{
                    display: 'flex',
                    // flexGrow: 1,
                    justifyContent: 'flex-end'
                }}
            >
                <Link to={{ pathname: url }} target="_blank" >
                    <Texts.Paragraph sx={{
                        color: 'primary'
                    }}>全文を読む</Texts.Paragraph>
                </Link>
            </Box>
        </Stack>


    </Paper>)
}

export default UrlContentPreview